<template>
  <a-card :title="header">
    <div class="table-wrapper">
      <div class="item" v-for="(item, index) in tableModel" :key="index">
        <div class="left">{{ item.label }}</div>
        <div class="right">{{ tableData[item.key] }}</div>
      </div>
    </div>
  </a-card>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: '',
    },
    tableModel: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style scoped lang="less">
.left,
.right {
  width: 50%;
  line-height: 32px;
  font-size: 14px;
}
.item {
  display: flex;
  border-bottom: 1px solid #e6e9f4;
  padding: 0 16px;
}
.table-wrapper {
  width: 100%;
  border: 1px solid #e6e9f4;
  border-bottom: none;
}
</style>
